import { makeStyles } from '@material-ui/core';
import { Theme } from '@mui/material';
import Colors from 'modules/Colors';
import styled from 'styled-components';

const useStyles = makeStyles((theme: Theme) => ({
  dataGridRoot: {
    border: "1px solid #EDECF2",
    outline: "none !important",
    '& .MuiDataGrid-row:hover': {
      background: '#EDECF2 !important',
    },
    "& .MuiDataGrid-main, .MuiDataGrid-root": {
      border: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle, .MuiDataGrid-cell": {
      color: Colors.greyDark,
      padding: 16,
    },
    '& .MuiDataGrid-cell:focus': {
      outline: 'none',
      borderBottom: `1px solid #EDECF2`,
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none"
    },
    "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell, .MuiDataGrid-row": {
      borderBottom: `1px solid #EDECF2`,
      cursor: "pointer",
    },
    '& .MuiDataGrid-iconButtonContainer': {
      marginLeft: 2,
      visibility: 'visible !important',
      width: 'auto !important',
    },
    '& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus': {
      outline: 'none !important',
    },
  }
}));

export const EmailCellContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const UserDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const UserInformationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
`;

export const NameContainer = styled.div`
  font-size: 12px;
  color: ${Colors.greyDark};
`;

export const NewFanContainer = styled.div`
  padding: 4px;
  background: rgba(136, 0, 255, 0.08);
  border-radius: 4px;
  font-family: 'DIN';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: ${Colors.purple};
`;

export const GrayText = styled.span`
  color: #FFFFFF72;
`;

export const WhiteText = styled.span`
  color: white;
`;

export const BlurContainer = styled.div`
  filter: blur(5px);
`;

export default useStyles;
